// import { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useAuth } from '../context/AuthContext';
// import { Scale, Eye, EyeOff } from 'lucide-react';

// export default function Login() {
//   const { login, error } = useAuth();
//   const navigate = useNavigate();
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [show, setShow] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     const ok = await login(email, password);
//     if (ok) navigate('/');
//     setLoading(false);
//   };

//   return (
//     <div style={{
//       minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
//       background: 'var(--bg)',
//       backgroundImage: 'radial-gradient(ellipse 60% 40% at 50% 0%, rgba(0,194,255,0.06) 0%, transparent 70%)',
//     }}>
//       <div style={{ width: '100%', maxWidth: 400, padding: '0 20px' }}>
//         {/* Logo */}
//         {/* <div style={{ textAlign: 'center', marginBottom: 40 }}>
//           <div style={{
//             width: 56, height: 56, borderRadius: 16,
//             background: 'var(--accent-dim)', border: '1px solid rgba(0,194,255,0.3)',
//             display: 'flex', alignItems: 'center', justifyContent: 'center',
//             margin: '0 auto 16px',
//           }}>
//             <Scale size={26} color="var(--accent)" />
//           </div>
//           <h1 style={{ fontSize: 24, fontWeight: 700, letterSpacing: '-0.04em' }}>WeightQA</h1>
//           <p style={{ color: 'var(--text2)', fontSize: 13, marginTop: 4 }}>
//             Real-Time Weight Tracking System
//           </p>
//         </div> */}

//         {/* Logo */}
//         <div style={{ textAlign: 'center', marginBottom: 40 }}>
//           <div style={{
//             width: 72, height: 72, borderRadius: 16,
//             overflow: 'hidden',
//             display: 'flex', alignItems: 'center', justifyContent: 'center',
//             margin: '0 auto 16px',
//           }}>
//             <img
//               src="/image1.png"
//               alt="WeightQA"
//               style={{ width: '100%', height: '100%', objectFit: 'contain' }}
//             />
//           </div>
//           <h1 style={{ fontSize: 24, fontWeight: 700, letterSpacing: '-0.04em' }}>WeightTrackingSystem</h1>
//           <p style={{ color: 'var(--text2)', fontSize: 13, marginTop: 4 }}>
//             Real-Time Weight Tracking System
//           </p>
//         </div>

//         {/* Card */}
//         <div className="card" style={{ padding: 28 }}>
//           <h2 style={{ fontSize: 15, fontWeight: 600, marginBottom: 20 }}>Sign in to your account</h2>

//           {error && (
//             <div style={{
//               background: 'rgba(255,77,106,0.1)', border: '1px solid rgba(255,77,106,0.3)',
//               borderRadius: 8, padding: '10px 14px', marginBottom: 16,
//               fontSize: 13, color: 'var(--danger)'
//             }}>{error}</div>
//           )}

//           <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
//             <div className="form-group">
//               <label>Email Address</label>
//               <input type="email" value={email} onChange={e => setEmail(e.target.value)}
//                 placeholder="you@company.com" required />
//             </div>

//             <div className="form-group">
//               <label>Password</label>
//               <div style={{ position: 'relative' }}>
//                 <input type={show ? 'text' : 'password'} value={password}
//                   onChange={e => setPassword(e.target.value)}
//                   placeholder="••••••••" required style={{ paddingRight: 40 }} />
//                 <button type="button" onClick={() => setShow(!show)} style={{
//                   position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)',
//                   background: 'none', color: 'var(--text3)', padding: 0
//                 }}>
//                   {show ? <EyeOff size={15} /> : <Eye size={15} />}
//                 </button>
//               </div>
//             </div>

//             <button type="submit" className="btn-primary"
//               style={{ marginTop: 4, padding: '10px', fontSize: 14, width: '100%' }}
//               disabled={loading}>
//               {loading ? 'Signing in...' : 'Sign In'}
//             </button>
//           </form>
//         </div>

//         <p style={{ textAlign: 'center', marginTop: 20, fontSize: 11, color: 'var(--text3)' }}>
//           Powered by Eptiq Technology.
//         </p>
//       </div>
//     </div>
//   );
// }

// ************************************************************************************  ajay:code 01-08-26

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  Eye,
  EyeOff,
  Mail,
  Lock,
  Crosshair,
  BarChart3,
  ShieldCheck,
  Settings2,
  ArrowRight,
} from "lucide-react";

const FEATURES = [
  {
    icon: Crosshair,
    title: "Real-time Accuracy",
    desc: "Precise weight capture in real-time",
  },
  {
    icon: BarChart3,
    title: "Data Insights",
    desc: "Actionable insights & performance reports",
  },
  {
    icon: ShieldCheck,
    title: "Traceability",
    desc: "Complete tracking & audit compliance",
  },
  {
    icon: Settings2,
    title: "Automation Ready",
    desc: "Seamless integration with your existing systems",
  },
];

export default function Login() {
  const { login, error } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [remember, setRemember] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email, password);
    if (ok) navigate("/");
    setLoading(false);
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100vw",
        display: "grid",
        gridTemplateColumns: "60% 40%",
        background: "#EEF3F9",
        padding: 0,
        boxSizing: "border-box",
      }}
      className="login-grid"
    >
      {/* ── Left panel — brand / marketing side ── */}
      <div
        className="login-left"
        style={{
          position: "relative",
          padding: "80px 60px",
          color: "#fff",
          overflow: "hidden",
          // background:
          //   "linear-gradient(rgba(8,25,60,.78), rgba(8,25,60,.28)), url('/login-bg.png') left center / cover no-repeat",
          background:
            "linear-gradient(115deg, rgba(6,14,34,0.92) 0%, rgba(8,25,60,.78) 35%, rgba(10,28,58,0.42) 65%, rgba(8,25,60,.28) 100%), url('/login-bg.png') left center / cover no-repeat",

          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          minHeight: "calc(100vh - 32px)",
          height: "100%",
          // borderRadius: 22,
        }}
      >
        <div style={{ marginBottom: 40 }}>
          <h1
            style={{
              fontSize: 34,
              fontWeight: 800,
              lineHeight: 1.25,
              letterSpacing: "-0.02em",
              margin: 0,
            }}
          >
            Smart Weighing.
            <br />
            Smarter Manufacturing.
          </h1>
          <p
            style={{
              color: "rgba(255,255,255,0.75)",
              marginTop: 14,
              maxWidth: 420,
              fontSize: 22,
              lineHeight: 1.6,
            }}
          >
            Real-time Weight Tracking for Accuracy, Efficiency & Complete
            Traceability.
          </p>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 22 }}>
          {FEATURES.map((f) => (
            <div
              key={f.title}
              style={{ display: "flex", alignItems: "flex-start", gap: 14 }}
            >
              <div
                style={{
                  width: 60,
                  height: 60,
                  border: "2px solid rgba(255,255,255,.25)",
                  borderRadius: "50%",
                  flexShrink: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <f.icon size={18} color="#fff" />
              </div>
              <div>
                <div style={{ fontSize: 14, fontWeight: 700 }}>{f.title}</div>
                <div
                  style={{
                    fontSize: 12.5,
                    color: "rgba(255,255,255,0.65)",
                    marginTop: 2,
                    lineHeight: 1.4,
                  }}
                >
                  {f.desc}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ── Right panel — sign in form ── */}
      <div
        className="login-right"
        style={{
          padding: "60px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          background: "#fff",
          borderRadius: 22,
          boxShadow: "0 15px 45px rgba(0,0,0,.08)",
          minHeight: "calc(100vh - 32px)",
        }}
      >
        <div
          className="login-form"
          style={{
            maxWidth: 460,
            width: "100%",
            margin: "0 auto",
          }}
        >
          {/* Logo */}
          <img
            src="/Eptiq-logo.jpeg"
            alt="EPTIQ Technologies"
            style={{
              width: "180px",
              height: "auto",
              objectFit: "contain",
              display: "block",
              margin: "0 auto 20px",
            }}
          />

          <h2
            style={{
              textAlign: "center",
              fontSize: 20,
              fontWeight: 800,
              color: "#111827",
              marginTop: 18,
              marginBottom: 2,
            }}
          >
            WeightTrackingSystem
          </h2>
          <p
            style={{
              textAlign: "center",
              fontSize: 12.5,
              color: "#8A93A6",
              marginBottom: 28,
            }}
          >
            Real-Time Weight Tracking System
          </p>

          <h3
            style={{
              fontSize: 17,
              fontWeight: 700,
              color: "#111827",
              marginBottom: 2,
            }}
          >
            Welcome Back!
          </h3>
          <p style={{ fontSize: 13, color: "#8A93A6", marginBottom: 22 }}>
            Sign in to continue to your account
          </p>

          {error && (
            <div
              style={{
                background: "#FDECEC",
                border: "1px solid #F5B8B8",
                borderRadius: 8,
                padding: "10px 14px",
                marginBottom: 16,
                fontSize: 13,
                color: "#C0392B",
              }}
            >
              {error}
            </div>
          )}

          <form
            onSubmit={handleSubmit}
            style={{ display: "flex", flexDirection: "column", gap: 16 }}
          >
            <div>
              <label style={lightLabel}>Email Address</label>
              <div style={{ position: "relative" }}>
                <Mail size={16} color="#9AA3B5" style={iconLeft} />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@company.com"
                  required
                  style={lightInput}
                />
              </div>
            </div>

            <div>
              <label style={lightLabel}>Password</label>
              <div style={{ position: "relative" }}>
                <Lock size={16} color="#9AA3B5" style={iconLeft} />
                <input
                  type={show ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  required
                  style={{ ...lightInput, paddingRight: 40 }}
                />
                <button
                  type="button"
                  onClick={() => setShow(!show)}
                  style={{
                    position: "absolute",
                    right: 12,
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "none",
                    border: "none",
                    color: "#9AA3B5",
                    padding: 0,
                    cursor: "pointer",
                    display: "flex",
                  }}
                >
                  {show ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>

            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                fontSize: 13,
                color: "#4B5563",
                cursor: "pointer",
              }}
            >
              <input
                type="checkbox"
                checked={remember}
                onChange={(e) => setRemember(e.target.checked)}
                style={{ width: 15, height: 15, cursor: "pointer" }}
              />
              Remember me
            </label>

            <button
              type="submit"
              disabled={loading}
              style={{
                marginTop: 4,
                // padding: "13px",
                height: 56,
                borderRadius: 12,
                fontSize: 18,
                fontWeight: 700,
                width: "100%",
                borderRadius: 10,
                border: "none",
                color: "#fff",
                cursor: loading ? "default" : "pointer",
                background: "linear-gradient(90deg, #1E6FE8 0%, #1856C4 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
                opacity: loading ? 0.75 : 1,
              }}
            >
              {loading ? (
                "Signing in..."
              ) : (
                <>
                  Sign In <ArrowRight size={16} />
                </>
              )}
            </button>
          </form>

          <p
            style={{
              textAlign: "center",
              marginTop: 28,
              fontSize: 11.5,
              color: "#B0B7C3",
            }}
          >
            Powered by Eptiq Technology.
          </p>
        </div>
      </div>

      {/* Stack panels vertically on narrow screens */}
      <style>{`
        @media (max-width:1100px){

.login-grid{
grid-template-columns:1fr!important;
padding:0!important;
}

.login-left{
display:none!important;
}

.login-right{
border-radius:0!important;
min-height:100vh!important;
padding:40px 25px!important;
}

.login-form{
max-width:420px!important;
}

}

@media (max-width:600px){

.login-right{
padding:28px 18px!important;
}

.login-form{
max-width:100%!important;
}

}
      `}</style>
    </div>
  );
}

const lightLabel = {
  display: "block",
  fontSize: 12.5,
  fontWeight: 600,
  color: "#374151",
  marginBottom: 6,
};
const iconLeft = {
  position: "absolute",
  left: 13,
  top: "50%",
  transform: "translateY(-50%)",
};
const lightInput = {
  width: "100%",
  padding: "11px 14px 11px 38px",
  borderRadius: 9,
  border: "1px solid #E2E5EB",
  // background: "#F8F9FB",
  background: "#fff",
  height: 54,
  border: "1px solid #D8DFEA",
  borderRadius: 12,
  fontSize: 15,
  color: "#111827",
  fontSize: 13.5,
  outline: "none",
  boxSizing: "border-box",
};
